// noinspection BadExpressionStatementJS

import React, {useEffect, useState} from 'react'
import '../css/investor.css'
import {useWeb3React} from "@web3-react/core";
import {Web3Provider} from "@ethersproject/providers";
import { addPhetaToken, getCampaignContract, getPhetaTokenContract, prettyPrintBigNumber } from "../utils";
import {InvestorCheckPage} from "./investor-check";
import {InvestorBuyPage} from "./investor-buy-page";
import { getTokenFromLocationHash } from "../app";
import Background from "../components/assets/img/bg.jpg";
import backArrow from "../components/assets/img/arrow-left.png";

// Token: 0x299581481cf08c8d7dd3a482ee2e10b264dde2d4b01c5d9fdfb5d6bbbc1ab627
// Token: 0x14809fbf03902fb2b4760c326c821a32d3f93dca59870fb7f797d232e5a027eb

export function BalanceActivationPage({language}) {
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React<Web3Provider>()
    const [balance, setBalance] = useState<string>()
    const [showBuyPage, setShowBuyPage] = useState(false)
    const [loading, setLoading] = useState(true)
    const [done, setDone] = useState(false)

    const balanceActivationToken = getTokenFromLocationHash()

    useEffect(() => {
        (async () => {
            const campaignContract = await getCampaignContract(library)
            const balanceBN = await campaignContract.getExternalBalance(balanceActivationToken)
            setBalance(balanceBN.isZero() ? '' : prettyPrintBigNumber(balanceBN))
            setLoading(false)
            // setPublicRoundActive(await campaignContract.publicRoundActive())
        })().then()
    }, [])

    const attachTokens = async () => {
        setLoading(true)
        try {
            const campaignContract = await getCampaignContract(library)
            const tx = await campaignContract.approveExternalBalance(balanceActivationToken)
            await tx.wait()
            // gas used: 99542
            setDone(true)
            // window.location.href = ''
        } catch (e) {
            console.log(e)
            if (e && e.error && e.error.message) {
                alert(e.error.message)
            }
        }
        setLoading(false)
    }

    if (balance === undefined )
        return <div>Loading...</div>
    else return (
        <section className={'c'} style={{backgroundImage: `url(${Background})`}}>
            <div className={'c-content'}>
                <div className={'c-content-container'}>

                    { balance && done &&
                        <>
                            <p className={'c-address'}>{language === 'ru' ? 'Ваш адрес' : 'Your address'}: <span>{account}</span></p>
                            <div className={'c-buy-container'}>
                                <h2 className={'c-buy-title'}>You have {balance} PHETA</h2>
                                <p className={'c-buy-form-amount-desc'}>
                                    Congratulations! Now your PHETA will be accessible on this wallet after vesting start.
                                </p>
                                <div className="c-btn">
                                    <a className={'c-btn-link'} href={'/'}>
                                        Check balance
                                    </a>
                                </div>
                            </div>
                        </>
                    }
                    { balance && !done &&
                        <>
                            <p className={'c-address'}>{language === 'ru' ? 'Ваш адрес' : 'Your address'}: <span>{account}</span></p>
                            <div className={'c-buy-container'}>
                                <h2 className={'c-buy-title'}>You have {balance} PHETA</h2>
                                <div className="c-btn">
                                    {loading ? ('Executing...') : (
                                        <a className={'c-btn-link'} onClick={attachTokens}>
                                            Attach {balance} PHETA to this wallet
                                        </a>
                                    )}
                                </div>
                            </div>
                        </>
                    }
                    { !balance && (
                        <>
                            <p className={'c-address'}>{language === 'ru' ? 'Ваш адрес' : 'Your address'}: <span>{account}</span></p>
                            <div className={'c-buy-container'}>
                                <h3>Invalid link or this link already used</h3>
                                <div className="c-btn">
                                    <a className={'c-btn-link'} href={'/'}>
                                        Check balance
                                    </a>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </section>
    )
}

























// export function InvestorPage({language}) {
//     return (
//         <div className={'container'}>
//             <div className={'content'}>
//                 <div className={'content-container'}>
//                     <p className={'locked'}>{language === 'ru' ? 'токены фета заблокированы: ' : 'pheta tokens locked:'}<span className={'locked-value'}>990</span></p>
//                     <p className={'unlocked'}>{language === 'ru' ? 'токены фета разблокированы: ' : 'pheta tokens unlocked:'}<span className={'unlocked-value'}>10</span></p>
//                     <a className={'content-button'}>{language === 'ru' ? 'получить 10 токенов' : 'get 10 tokens'}</a>
//                 </div>
//             </div>
//             <div className={'container'}>
//                 <div className="button-more-container">
//                     <a className="button-more">{language === 'ru' ? 'купить больше' : 'buy more'}</a>
//                 </div>
//             </div>
//         </div>
//     )
// }
